import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import WarningIcon from "@mui/icons-material/Warning";
import { Box } from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullScreenWarningDilogue } from "./style";

const InterviewFullScreenDilogue = ({ open, onEnterFullScreen }) => {
  return (
    <FullScreenWarningDilogue
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box className="warning-header">
        <WarningIcon className="warning-icon" />
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          Return to Full Screen Mode
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" className="dialog-text">
          You have exited fullscreen mode. To continue with the interview,
          please return to full screen mode.
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onEnterFullScreen} className="fullscreen-button" variant="outlined">
          Enter Full Screen
          <FullscreenIcon className="fullscreen-icon" />
        </Button>
      </DialogActions>
    </FullScreenWarningDilogue>
  );
};

export default InterviewFullScreenDilogue;
